import {useModelDispatchers} from "../../../models";
import React from "react";
import {ProfileTwoTone} from "@ant-design/icons";
import {Button, Card, Form, Input, message} from "antd";
import {DICT_KEY, getCmDict, setCmDict} from "../../../utils/constants";


export default function () {
    const [form] = Form.useForm();
    const {closeNav} = useModelDispatchers("nav");
    const onClose = () => {
        closeNav();
    }
    const CacheForm = () => {
        return (
            <Form
                form={form}
                name="material_detail"
                labelCol={{span: 4}}
                onValuesChange={el => {
                    Object.keys(el).forEach(key => {
                        setCmDict(key, !!el[key] ? JSON.parse(el[key]) : null);
                    });
                    message.success("修改成功!");
                }}
            >
                {
                    Object.keys(DICT_KEY.CM_DICT).map(el => {
                        return (
                            <Form.Item
                                name={DICT_KEY.CM_DICT[el]}
                                label={DICT_KEY.CM_DICT[el]}
                                initialValue={JSON.stringify(getCmDict(DICT_KEY.CM_DICT[el], null, "\t"))}
                                style={{paddingRight: "32px"}}
                            >
                                <Input.TextArea/>
                            </Form.Item>
                        )
                    })
                }
            </Form>
        )
    }
    const Title = () => {
        return (
            <div style={{display: "flex"}}>
                <h3 style={{flex: "1"}}>
                    <ProfileTwoTone/>
                    <span className="margin-left-8">缓存管理</span>
                </h3>
                <div style={{width: "600px", textAlign: "right"}}>
                    <Button className="margin-left-8" onClick={onClose}>关闭</Button>
                </div>
            </div>
        )
    }
    return (
        <Card
            title={<Title/>}
            bordered={true}
            className="margin-top-8"
        >
            <CacheForm/>

        </Card>
    );
}